import {
  PublicKey,
  Transaction,
  SystemProgram,
  Connection,
} from "@solana/web3.js";
import {
  createTransferInstruction,
  getAssociatedTokenAddress,
} from "@solana/spl-token";
import { getProvider } from "./conn";

const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : 'https://api.ssm.casino/';

declare global {
  interface Window {
    betamount: number;
    betwith: string;
    solana: any;
  }
}

// Get the most recent betwith and betamount from the local storage, and store them in the window object

export const spin = async (betType: string, betAmount: number, address: string): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      let tx: string | undefined;

      if (betType === "SOL") {
        tx = await sendSOL(betAmount);
      } else if (betType === "SSM") {
        tx = await sendToken(betAmount);
      }

      if (!tx) throw new Error("Transaction failed");

      setTimeout(async () => {
        try {
          const data = {
            walletAddress: address,
            stakeAmount: betAmount,
            stakeTokenType: betType,
            tx,
          };
          const response = await fetch(API_URL + "api/game/play", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
          let result = await response.json();
          // send tx to the server and get the result
          resolve(result.win);
        } catch (error) {
          console.error("Error during spin:", error);
          resolve("0"); // Return "0" on error
        }
      }, 1000);
    } catch (error) {
      console.error("Error during spin:", error);
      resolve("0"); // Return "0" on error
    }
  });
};

export const sendSOL = async (amountSOL: number): Promise<string> => {
  const { solana } = window;
  if (!solana || !solana.isPhantom) {
    throw new Error("Phantom Wallet not found");
  }

  // Connect to the wallet
  const connection = new Connection("https://rpc.shyft.to?api_key=dU1qN127ZwYqbLfj"); // Use mainnet or devnet/testnet as needed
  const walletPublicKey = solana.publicKey || (await solana.connect()).publicKey;

  if (!walletPublicKey) {
    throw new Error("Wallet not connected");
  }

  // Replace with the recipient's wallet address
  const recipient = new PublicKey("2SdikmLixYH2CEpXrdF5az5b3SxcHr7hSo5nnG3WFs3G");

  // Convert SOL amount to lamports (1 SOL = 1e9 lamports)
  const lamports = amountSOL * 1e9;

  // Create a transaction to transfer SOL
  const transaction = new Transaction().add(
    SystemProgram.transfer({
      fromPubkey: walletPublicKey, // Sender's public key
      toPubkey: recipient, // Recipient's public key
      lamports, // Amount in lamports
    })
  );

  // Set recentBlockhash and feePayer
  transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
  transaction.feePayer = walletPublicKey;

  // Request the wallet to sign the transaction
  const signedTransaction = await solana.signTransaction(transaction);

  // Send the transaction
  const signature = await connection.sendRawTransaction(signedTransaction.serialize());
  await connection.confirmTransaction(signature, "confirmed");

  console.log(`SOL transfer sent with signature: ${signature}`);
  return signature;
};

export const sendToken = async (amount: number): Promise<string> => {
  const { solana } = window;
  if (!solana || !solana.isPhantom) {
    throw new Error("Phantom Wallet not found");
  }

  // Connect to the wallet
  const connection = new Connection("https://rpc.shyft.to?api_key=dU1qN127ZwYqbLfj"); // Use mainnet or devnet/testnet as needed
  const walletPublicKey = solana.publicKey || (await solana.connect()).publicKey;

  if (!walletPublicKey) {
    throw new Error("Wallet not connected");
  }

  // Replace with your token mint and recipient
  const tokenMint = new PublicKey("Bre6EkdRj2ZtRCcqGoLXCWYebpTub3DxqPvYhZV7moon");
  const recipient = new PublicKey("2SdikmLixYH2CEpXrdF5az5b3SxcHr7hSo5nnG3WFs3G");

  // Derive the sender's and recipient's associated token accounts
  const senderTokenAccount = await getAssociatedTokenAddress(tokenMint, walletPublicKey);
  const recipientTokenAccount = await getAssociatedTokenAddress(tokenMint, recipient);

  console.log(`Sender token account: ${senderTokenAccount.toBase58()}`);
  console.log(`Recipient token account: ${recipientTokenAccount.toBase58()}`);


  // Create the transfer instruction
  const transferInstruction = createTransferInstruction(
    senderTokenAccount,  // Sender's associated token account
    recipientTokenAccount, // Recipient's associated token account
    walletPublicKey, // Authority to sign
    amount * 10 ** 9 // Convert amount to smallest token unit (adjust decimals as per token)
  );

  // Create the transaction
  const transaction = new Transaction().add(transferInstruction);
  transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
  transaction.feePayer = walletPublicKey;

  // Request the wallet to sign the transaction
  const signedTransaction = await solana.signTransaction(transaction);

  // Send the transaction
  const signature = await connection.sendRawTransaction(signedTransaction.serialize());
  await connection.confirmTransaction(signature, "confirmed");

  console.log(`Token transfer sent with signature: ${signature}`);
  return signature;
};
